/**
 * Sort Direction Enum
 *
 * Defines the sorting direction options for data queries and displays.
 * - ASC: Ascending order (A-Z, 0-9, oldest to newest)
 * - DESC: Descending order (Z-A, 9-0, newest to oldest)
 */
export enum SortDirectionEnum {
  ASC = "ASC",   // Ascending
  DESC = "DESC"  // Descending
}
